// Formats a date string as "MM/DD/YYYY, hh:mm AM/PM" for consistent date + time display
export const formatDateTime = (dateString) => {
  if (!dateString) return 'N/A';

  const date = new Date(dateString);
  const datePart = date.toLocaleDateString();
  const timePart = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  return `${datePart}, ${timePart}`;
};
